// extracted by mini-css-extract-plugin
module.exports = {"gambar":"Home_gambar__2H8T5","container":"Home_container__3bftD","footer":"Home_footer__OfA9i"};